import React, { useState, forwardRef, useImperativeHandle } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faCircleInfo } from "@fortawesome/free-solid-svg-icons";

/**
 * FULL SWIPE FLOW DATA (clean separation)
 */
const steps = [
    {
        title: "HOOK",
        color: "red",
        text: "Are you building like a founder… or just staying busy?",
        sub: "Swipe mindset starts here.",
    },
    {
        title: "REALITY CHECK",
        color: "blue",
        text: "Your behavior is already tracking you.",
        sub: "Every task = data about you.",
    },
    {
        title: "SYSTEM INTRO",
        color: "yellow",
        text: "We convert behavior into Founder Score.",
        sub: "No motivation. Only data.",
    },
    {
        title: "WHAT YOU GET",
        color: "green",
        text: "Founder Score, Archetype, Weaknesses.",
        sub: "Weekly growth direction.",
    },
    {
        title: "INSIGHT",
        color: "purple",
        text: "Most people never see this about themselves.",
        sub: "You will.",
    },
    {
        title: "FINAL CTA",
        color: "cyan",
        text: "Start your Founder Journey",
        sub: "Take your first test.",
    },
];

/**
 * ICON (optional reuse anywhere)
 */
export const PDStartupHelpIcon = ({ onClick }) => (
    <button
        onClick={onClick}
        className="w-10 h-10 flex items-center justify-center rounded-xl bg-cyan-500/20 text-cyan-300"
    >
        <FontAwesomeIcon icon={faCircleInfo} />
    </button>
);

/**
 * MAIN COMPONENT (CONTROLLED + REUSABLE)
 */
const PDStartupHelp = forwardRef((props, ref) => {
    const [open, setOpen] = useState(false);

    useImperativeHandle(ref, () => ({
        open: () => setOpen(true),
        close: () => setOpen(false),
        toggle: () => setOpen((p) => !p),
    }));

    return (
        <AnimatePresence>
            {open && (
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 20 }}
                    className="
                        fixed inset-0 z-50
                        bg-black/95
                        flex flex-col
                    "
                >
                    {/* HEADER */}
                    <div className="flex justify-between items-center p-3 border-b border-gray-800">
                        <div className="text-xs text-cyan-300 font-bold">
                            🚀 Startup Onboarding Flow
                        </div>

                        <button
                            onClick={() => setOpen(false)}
                            className="w-10 text-xs text-gray-300 hover:text-red-400"
                        >
                            <FontAwesomeIcon icon={faXmark} />
                        </button>
                    </div>

                    {/* SWIPE CONTENT (future upgrade: gesture-based) */}
                    <div className="p-4 space-y-3 overflow-y-auto">
                        {steps.map((s, i) => (
                            <div
                                key={i}
                                className="bg-[#111827] border border-gray-800 rounded-2xl p-4"
                            >
                                <div className="text-xs text-cyan-300 font-bold">
                                    {i + 1}. {s.title}
                                </div>

                                <div className="text-sm text-white mt-1">
                                    {s.text}
                                </div>

                                <div className="text-xs text-gray-400 mt-1">
                                    {s.sub}
                                </div>
                            </div>
                        ))}
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
});

export default PDStartupHelp;